import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    proxy: 'http://127.0.0.1:3001',
    user: null,
    keycloak: null
  },
  mutations: {},
  actions: {},
  modules: {
  },
  getters: {}
});
